import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  titleAr,
  description,
  descriptionAr,
  keywords = [],
  keywordsAr = [],
  url,
  image,
  siteName = "AlSaket Dental Clinics",
  siteNameAr = "عيادات الساكت لطب الأسنان",
  noindex = false,
  structuredData = [],
  lang = "en"
}) {
  const metaKeywords = keywords.join(", ");
  const metaKeywordsAr = keywordsAr.join(", ");
  const finalTitle = titleAr && lang === "ar" ? titleAr : title;
  const finalDescription = descriptionAr && lang === "ar" ? descriptionAr : description;
  const finalKeywords = keywordsAr.length > 0 && lang === "ar" ? metaKeywordsAr : metaKeywords;
  const finalSiteName = lang === "ar" ? siteNameAr : siteName;

  const isRTL = lang === 'ar';
  const dir = isRTL ? 'rtl' : 'ltr';

  return (
    <Helmet prioritizeSeoTags>
      {/* Language and Basic Meta */}
      <html lang={lang} dir={dir} />
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}

      {/* Title and Description */}
      {finalTitle && <title>{finalTitle} | {finalSiteName}</title>}
      {finalDescription && <meta name="description" content={finalDescription} />}
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}

      {/* Canonical */}
      {url && <link rel="canonical" href={url} />}

      {/* Language Alternatives */}
      {url && (
        <>
          <link rel="alternate" hrefLang="en" href={url} />
          <link rel="alternate" hrefLang="ar" href={url} />
          <link rel="alternate" hrefLang="x-default" href={url} />
        </>
      )}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "ar" ? "ar_JO" : "en_US"} />
      {finalSiteName && <meta property="og:site_name" content={finalSiteName} />}
      {finalTitle && <meta property="og:title" content={`${finalTitle} | ${finalSiteName}`} />}
      {finalDescription && <meta property="og:description" content={finalDescription} />}
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:width" content="1200" />}
      {image && <meta property="og:image:height" content="630" />}

      {/* Twitter */}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:site" content="@alsaketdental" />
      {finalTitle && <meta name="twitter:title" content={`${finalTitle} | ${finalSiteName}`} />}
      {finalDescription && <meta name="twitter:description" content={finalDescription} />}
      {image && <meta name="twitter:image" content={image} />}

      {/* Additional SEO Meta */}
      <meta name="author" content="Dr. Yousef AlSaket" />
      <meta name="geo.region" content="JO" />
      <meta name="geo.placename" content="Amman" />
      <meta name="geo.position" content="31.9539;35.9106" />
      <meta name="ICBM" content="31.9539, 35.9106" />

      {/* Structured Data JSON-LD */}
      {structuredData.map((data, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </Helmet>
  );
}
